import { HamletClient, IHamletClient } from '@atlassiansox/asc-hamlet';
import React, { createContext, PropsWithChildren, useContext } from 'react';

const HamletClientContext = createContext<IHamletClient>(new HamletClient());

export function useHamletClient(): IHamletClient {
  return useContext(HamletClientContext);
}

export type HamletClientProviderProps = PropsWithChildren<{
  readonly client: IHamletClient;
}>;

export function HamletClientProvider({
  client,
  children
}: HamletClientProviderProps) {
  return (
    <HamletClientContext.Provider value={client}>
      {children}
    </HamletClientContext.Provider>
  );
}
